module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/344.2b5c4407.png";